import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 400,
  bgcolor: "transparent",
  boxShadow: "none",
  p: 0,
  outline: "none",
};

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message }) {
  return (
    <Modal open={isOpen} onClose={onClose} closeAfterTransition sx={{ zIndex: 2000 }}>
      <Box sx={modalStyle}>
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden border border-gray-100 dark:border-gray-700 m-4 animate-fade-in">
          <div className="px-6 py-4 flex justify-between items-center border-b border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/80">
            <Typography variant="h6" className="font-semibold text-gray-800 dark:text-gray-200">
              {title || "Xác nhận hành động"}
            </Typography>
            <IconButton size="small" onClick={onClose} className="text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors">
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
          
          <div className="p-6 flex items-start gap-4">
            <div className="p-3 rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 shrink-0">
              <WarningAmberIcon fontSize="medium" />
            </div>
            <div>
              <Typography className="text-gray-600 dark:text-gray-300 mt-1 leading-relaxed">
                {message || "Bạn có chắc chắn muốn thực hiện hành động này không? Thao tác này có thể sẽ không thể hoàn tác."}
              </Typography>
            </div>
          </div>
          
          <div className="px-6 py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/80 flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600 transition-colors"
            >
              Hủy bỏ
            </button>
            <button
              type="button"
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="px-5 py-2 text-sm font-medium text-white transition-colors bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-offset-gray-900 shadow-sm"
            >
              Xác nhận
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
